export default {
  strategic_plans: [],
  strategic_plan: null,
  pagination: {},
  tree_plan_structure: [],
};
